<template>
  <div>
    <challenge-listing style="padding: 12px;"
      :title="title"
      :challenges="challengesNotEmpty"
      :archivePage="true"
      :challengesLoaded="challengesLoaded"
      :dropdownOptions="options"
      :pageInfos.sync="pageInfos"
      @action="action($event.challenge, $event.id)"
      @newPage="getPageOfChallengesForOrg($event.pageNum, $event.pageSize, $event.orgId)"
    />
    <DeleteChallengeDialog
      :visible.sync="deleteModalVisible"
      :challenge="challengeToDelete"
      @confirm="deleteChallenge"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ChallengeListing from '@/components/challenge/challengeList/ChallengeListing.vue'
import DeleteChallengeDialog from '@/components/challenge/DeleteChallengeModal.vue'

export default {
  name: 'ArchivedChallengeList',

  props: ['global'],

  components: {
    ChallengeListing,
    DeleteChallengeDialog
  },

  data: () => ({
    challengesLoaded: false,
    pageInfos: {},
    deleteModalVisible: false,
    challengeToDelete: null,
    options: [
      { text: 'Edit', icon: 'mdi-pencil', anyoneCanAccess: true, id: 'edit' },
      { text: 'Restore', icon: 'mdi-restore', anyoneCanAccess: false, id: 'restore' },
      { text: 'Delete', icon: 'mdi-delete', anyoneCanAccess: false, id: 'delete' }
    ]
  }),

  async mounted () {
    await this.getPageOfChallenges(1, 5)
    this.challengesLoaded = true
    console.log(this.challenges)
  },

  computed: {
    ...mapState({
      challenges: state => state.challenge.archivedChallengesByOrg,
      organizations: state => state.organization.organizations
    }),

    challengesNotEmpty () {
      if (this.global) {
        return this.challenges.filter(c => c.challenges.length > 0)
      }
      return this.challenges
    },

    title () {
      if (this.global) {
        return 'Global Archived Challenges'
      } else {
        return 'Archived Challenges'
      }
    },

    organizationsWithChallenges () {
      if (this.global) {
        return this.organizations.filter(o => o.challenges > 0)
      }
      return []
    }
  },

  methods: {
    ...mapActions([
      'requestArchivedChallenges',
      'requestArchivedChallengesByOrg',
      'requestRestoreChallenge',
      'requestDeleteArchivedChallenge'
    ]),

    async getPageOfChallenges (pageNum, pageSize) {
      this.pageInfos = await this.requestArchivedChallenges({
        pageNum: pageNum,
        pageSize: pageSize,
        fetchGlobal: this.organizationsWithChallenges
      })
      console.log(this.pageInfos)
    },

    async getPageOfChallengesForOrg (pageNum, pageSize, orgId) {
      this.pageInfos[orgId] = await this.requestArchivedChallengesByOrg({
        pageNum: pageNum,
        pageSize: pageSize,
        orgId: orgId,
        global: this.global
      })
    },

    async action (challenge, eventId) {
      switch (eventId) {
        case 'restore':
          this.handleOperation(this.requestRestoreChallenge, challenge, 'Failed to restore challenge')
          break
        case 'edit':
          this.$router.push(`/admin-dashboard/challenge/${challenge.uuid}`)
          break
        case 'delete':
          this.challengeToDelete = challenge
          this.deleteModalVisible = true
          break
      }
    },

    deleteChallenge (challenge) {
      this.handleOperation(this.requestDeleteArchivedChallenge, challenge, 'Failed to delete challenge')
    },

    async handleOperation (operation, challenge, failMessage) {
      // do the operation
      const success = await operation(challenge)
      if (!success) {
        alert(failMessage)
      }

      // refresh the list
      let pageInfos = {}
      pageInfos = this.pageInfos[challenge.organization]
      this.getPageOfChallengesForOrg(pageInfos.pageNum, pageInfos.pageSize, challenge.organization)
    }
  }
}
</script>
